var _path, _path2, _path3, _path4, _path5, _path6, _rect, _path7, _rect2, _path8, _rect3, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersistenceGratitudeJournaling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 286,
    height: 143,
    viewBox: "0 0 286 143",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42 37C24.3269 37 10 51.3269 10 69C10 77.8366 13.5817 85.8366 19.3726 91.6274L11.0505 99.9495C10.6629 100.337 10.9374 101 11.4857 101H41.3846C41.4099 101 41.4348 100.998 41.4592 100.996C41.6391 100.999 41.8194 101 42 101C59.6731 101 74 86.6731 74 69C74 51.3269 59.6731 37 42 37Z",
    fill: "#F13F5F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0699 55.1639C44.5898 55.6273 43.2022 56.5541 41.9995 57.6662C40.7044 56.5541 39.4093 55.6273 37.9292 55.1639C32.4711 53.4956 27.8457 58.6857 27.8457 63.7832C27.8457 73.4219 39.9644 83.1534 41.9995 83.1534C44.0347 83.1534 56.1534 73.5146 56.1534 63.7832C56.1534 58.6857 51.3429 53.4956 46.0699 55.1639Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138 37C120.327 37 106 51.3269 106 69C106 77.8366 109.582 85.8366 115.373 91.6274L107.051 99.9495C106.663 100.337 106.937 101 107.486 101H137.385C137.41 101 137.435 100.998 137.459 100.996C137.639 100.999 137.819 101 138 101C155.673 101 170 86.6731 170 69C170 51.3269 155.673 37 138 37Z",
    fill: "#F13F5F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M142.07 55.1639C140.59 55.6273 139.202 56.5541 138 57.6662C136.704 56.5541 135.409 55.6273 133.929 55.1639C128.471 53.4956 123.846 58.6857 123.846 63.7832C123.846 73.4219 135.964 83.1534 138 83.1534C140.035 83.1534 152.153 73.5146 152.153 63.7832C152.153 58.6857 147.343 53.4956 142.07 55.1639Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M234 29C211.909 29 194 46.9086 194 69C194 80.0457 198.477 90.0457 205.716 97.2843L195.313 107.687C194.829 108.171 195.172 109 195.857 109H233.231C233.262 109 233.293 108.998 233.324 108.994C233.549 108.998 233.774 109 234 109C256.091 109 274 91.0914 274 69C274 46.9086 256.091 29 234 29Z",
    fill: "#F13F5F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M239.088 51.7053C237.238 52.2846 235.503 53.4431 234 54.8333C232.381 53.4431 230.762 52.2846 228.912 51.7053C222.089 49.62 216.308 56.1077 216.308 62.4794C216.308 74.5279 231.456 86.6922 234 86.6922C236.544 86.6922 251.692 74.6438 251.692 62.4794C251.692 56.1077 245.679 49.62 239.088 51.7053Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 152,
    y: 83,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M162.5 99L166.5 103L173.5 95",
    stroke: "#24284E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 83,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5 99L70.5 103L77.5 95",
    stroke: "#24284E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 83,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 264,
    cy: 99,
    r: 2,
    fill: "#24284E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 99,
    r: 2,
    fill: "#24284E"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 272,
    cy: 99,
    r: 2,
    fill: "#24284E"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 151,
    cy: 141,
    r: 2,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 14,
    r: 2,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 133.5,
    r: 1.5,
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 9.5,
    r: 1.5,
    fill: "white"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 132.5,
    cy: 2.5,
    r: 1.5,
    fill: "white"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 97.5,
    cy: 123.5,
    r: 1.5,
    fill: "white"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 207.5,
    cy: 130.5,
    r: 1.5,
    fill: "white"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 163.5,
    cy: 30.5,
    r: 1.5,
    fill: "white"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 284.5,
    cy: 33.5,
    r: 1.5,
    fill: "white"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 230.5,
    cy: 1.5,
    r: 1.5,
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M181.5 9L191 19",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M259.5 5L252.5 18.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M236.5 125.5L240.5 139.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersistenceGratitudeJournaling);
export default __webpack_public_path__ + "static/media/persistence-gratitude-journaling.21c069fa2ae88d1bb117a273ebb945f4.svg";
export { ForwardRef as ReactComponent };